import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../Common/styles/table";
import StatusBadge from "../../Common/UI/StatusTag";

const statusMap: any = {
  live: { label: "Live", variant: "active" },
  not_live: { label: "Not Live", variant: "cancelled" },
  closed: { label: "Closed", variant: "completed" },
};
type Props = {
  data: any;
};

const StudyDetails = ({ data }: Props) => {
  return (
    <Box sx={{ p: 2, backgroundColor: "#fff", borderRadius: "10px" }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "medium",
          color: "text.primary",
          mb: 2.5,
        }}
      >
        Study Details
      </Typography>
      <Table sx={TableBorderRadiusTopLeftRight}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Study Name</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 140 }}>
              Total Participants
            </StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>Start Date</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>Status</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>End Date</StyledTableCell>
          </TableRow>
        </TableHead>
        {data?.length > 0 && (
          <TableBody>
            {data?.map((row: any) => (
              <TableRow key={row?.id}>
                <StyledTableCell>{row?.studyName || "-"}</StyledTableCell>
                <StyledTableCell>{row?.participants ?? 0}</StyledTableCell>
                <StyledTableCell>{row?.startDate || "-"}</StyledTableCell>
                <StyledTableCell>
                  <StatusBadge
                    label={statusMap[row?.status]?.label ?? row?.status}
                    variant={statusMap[row?.status]?.variant}
                  />
                </StyledTableCell>
                <StyledTableCell>{row?.endDate || "-"}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      {data?.length === 0 && (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
    </Box>
  );
};

export default StudyDetails;
